import React, { useMemo } from 'react';
import objectPath from 'object-path';
import { useHtmlClassService } from '../../_core/MetronicLayout';
import Topbar from './Topbar';
import { AnimateLoading } from '../../../_partials/controls';
import { injectIntl } from 'react-intl';
import HeaderMenu from './header-menu/HeaderMenu';

function Header({ intl }) {
  const uiService = useHtmlClassService();

  const layoutProps = useMemo(() => {
    return {
      headerClasses: uiService.getClasses('header', true),
      headerAttributes: uiService.getAttributes('header'),
      headerContainerClasses: uiService.getClasses('header_container', true),
      menuHeaderDisplay: objectPath.get(
        uiService.config,
        'header.menu.self.display'
      ),
    };
  }, [uiService]);

  return (
    <>
      {/*begin::Header*/}
      <div
        className={`header ${layoutProps.headerClasses}`}
        id="kt_header"
        {...layoutProps.headerAttributes}
      >
        {/*begin::Container*/}
        <div
          className={` ${layoutProps.headerContainerClasses} d-flex align-items-center justify-content-between`}
        >
          <AnimateLoading />
          <div
            className="header-menu-wrapper header-menu-wrapper-left"
            id="kt_header_menu_wrapper"
          >
            <HeaderMenu layoutProps={layoutProps} />
          </div>
          <Topbar />
        </div>
      </div>
    </>
  );
}

export default injectIntl(Header);
